if (!customElements.get('son-daireler')) {
  class SonDaireler extends HTMLElement {
    constructor() {
      super();
      this.splideContainer = this.querySelector('.splide');
    }
    connectedCallback() {
      if (!this.splideContainer) return;
      
      // Slide sayısını kontrol et
      const slides = this.splideContainer.querySelectorAll('.splide__slide');
      if (slides.length === 0) return;
      
      this.splide = new Splide(this.splideContainer, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: 20,
        rewind: true,
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 5000,
        breakpoints: {
          1024: {
            arrows: false,
            pagination: true,
            perPage: 2,
          },
          768: {
            arrows: false,
            pagination: true,
            focus: "center",
            fixedWidth: 300,
          }
        }
      })
      this.splide.mount();
    }
  }
  customElements.define('son-daireler', SonDaireler)
}